import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { PrivateClientsFunnelValidationSchema } from "../schemas/create.schema";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from "axios";
import { unFormatCnpj } from "@/common/utils/unFormatters";
import { getCleanPayload } from "@/common/utils/getCleanPayload";

export type useCreatePrivateCompanyLead = (
  onSuccess: () => void,
  onError: (error: any) => void
) => UseMutationResult<AxiosResponse<any, any>, unknown, Partial<PrivateClientsFunnelValidationSchema>>

const useCreatePrivateCompanyLead: useCreatePrivateCompanyLead = (onSuccess, onError) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createPrivateCompanyLead'],
    mutationFn: async (form: Partial<PrivateClientsFunnelValidationSchema>) => {
      const payload = {
        display_name: form.display_name,
        general_information_attributes: {
          cnpj: form.general_information?.cnpj ? unFormatCnpj(form.general_information?.cnpj) : undefined,
        },
        contacts_attributes: [
          {
            ...form.contacts,
            phone_attributes: {
              ...form.contacts?.phone
            }
          }
        ],
        contract_attributes: {
          cycle: form.contract?.cycle ? form.contract?.cycle.value : undefined, 
          cycle_start_day: form.contract?.cycle_start_day ? form.contract?.cycle_start_day.value : undefined,
          cycle_fixed_interval: form.contract?.cycle?.value === 'fixed' && form.contract?.cycle_fixed_interval || undefined, 
        },
        observations: form.observations,
      }

      return privateAxios.post('/funnel/private_company_leads', {
        private_company_lead: getCleanPayload(payload)
      })
    },
    onSuccess: onSuccess,
    onError: onError
  });
}

export default useCreatePrivateCompanyLead
